import React from 'react';
import { FooterProps } from '../types';
import '../styles/Footer.css';

const DEFAULT_LOGO = '/assets/simphony_logo.svg';

const Footer: React.FC<FooterProps> = ({
  logo = DEFAULT_LOGO,
  estimationCode,
  versionText,
  confidentialText = 'Confidencial',
  websiteUrl = 'www.simphony.com.co'
}) => {
  return (
    <footer className="slide-footer">
      <div className="footer-section footer-logo-section">
        <img src={logo} alt="Logo" className="footer-logo" />
      </div>
      <div className="footer-section footer-estimation">
        {estimationCode && <span className="footer-text">{estimationCode}</span>}
      </div>
      <div className="footer-section footer-version">
        {versionText && <span className="footer-text">{versionText}</span>}
      </div>
      <div className="footer-section footer-confidential">
        <span className="footer-text">{confidentialText}</span>
      </div>
      <div className="footer-section footer-website">
        <span className="footer-text">{websiteUrl}</span>
      </div>
    </footer>
  );
};

export default Footer;
